export default __webpack_public_path__ + "components/wind-icon/static/N@2x-3c2df15904935e30e1e39aee8106be60.png";